<template>
    <label class="[&+*]:mt-1 text-sm block cursor-pointer font-semibold">
        <slot/>
    </label>
</template>
